    <template>
	<div>
		<v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link>
        <!-- <router-link :to="{name: 'eps-admin-master-menu' }" class="root">
            Super Master
        </router-link> -->
        <span class="child">/ Subject Authority Appointment</span>
    </v-row><br />
		<span>
        <v-btn color="blue" dark class="mb-2" :loading="isLoading" v-on="on" @click="synchcourseauthority()" style="margin:2px;float:right;">Synchronization Subject Authority from ERP</v-btn>
		</span>
		<br>
		<br>
		<v-card>
			<v-card-title class="justify-center heading"
				><h4>Subject Authority Appointment</h4></v-card-title
			>
			<v-card-text>
				<v-row align="center" justify="center">
					<!-- <v-col style="margin:5px;border-radius:50px;" md="3" v-for="link in link_data" :key="link.link" :class="[currentPage.includes(link.link)?activeClass:'inactive']">
              <router-link :to="{ name: link.link}" class="link">
                <v-list-item class="link-item">
                  <v-list-item-icon>
                    <v-icon>{{ link.icon }}</v-icon>
                  </v-list-item-icon>
  
                  <v-list-item-content>
                    <v-list-item-title>{{ link.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>
            </v-col> -->
					<v-row class="justify-center pt-5">
						<span
							lg="4"
							sm="12"
							cols="12"
							class="margin"
							v-for="link in link_data"
							:key="link.link"
						>
							<router-link :to="{ name: link.link }" class="link">
								<v-icon class="icon">{{ link.icon }}</v-icon>
								<span>{{ link.name }}</span>
							</router-link>
						</span>
					</v-row>
				</v-row>
			</v-card-text>
		</v-card>
		<br />
		<router-view />
	</div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";

export default {
	data: () => ({
		isLoading:false,
		link_data: [
			{
				link: "coe-subject-authority-appointment",
				icon: "mdi-copyright",
				name: "Assign Subject Authority"
			},
			{
				link: "coe-subject-authority-appointment-import",
				icon: "mdi-cogs",
				name: "Import Subject Authority Appointment"
			},
			{
				link: "All-Course-Authority",
				icon: "mdi-view-headline",
				name: "All Subject Authority Status"
			}
		],
		activeClass: "active"
	}),
	computed: {
		currentPage() {
			return this.$route.path;
		}
	},
	mounted() {
		this.$router.push({
			name: "coe-subject-authority-appointment"
		});
	},
	methods:
	{
		synchcourseauthority()
    {
      this.isLoading = true;
      axios
          .post("/Erpsynch/synchCourseAuthority")
          .then((res) => {
              if (res.data.status == "200") {
                  this.showSnackbar("#4caf50", "Course Authority Synchronized Successfully..!"); 
                  this.isLoading = false;
              } else if (res.data.status.code == "NA") {
                  this.showSnackbar("#b71c1c", "Error While Synchronization"); 
                  this.isLoading = false;
              }
              else{
                    this.showSnackbar("#b71c1c", "Error While Synchronization"); 
                    this.isLoading = false;
                }
          })
          .catch((error) => {
              window.console.log(error);
              this.isLoading = false;
          });
    },
	},
};
</script>
<style scoped>
.link {
	text-decoration: none;
	/* border: 3px solid hsla(190, 99%, 30%, 1); */
	border: 3px solid hsl(190deg 99% 30% / 64%) !important;
	padding: 1rem;
	border-radius: 30px;
	color: hsla(190, 99%, 30%, 1);
	font-size: 15px;
}

.margin {
	margin: 30px;
}

.router-link-active {
	background: red;
}

.active {
	/* background-color: hsla(190, 99%, 30%, 1); */
	background-color: #add8e630;
	color: hsla(190, 99%, 30%, 1);
box-shadow: 8px 8px 8px gray;}

.inactive {
	background: #ffd699;
}

@media only screen and (max-width: 600px) {
	.margin {
		margin: 20px 20px 20px 0px;
	}
}
</style>